/**
 * AIBadge - tiny, universal "AI" pill for track cards, leaderboard rows,
 * and search filters. Single source of truth so the brand is consistent.
 *
 * Props:
 *   size: 'xs' | 'sm' | 'md' (default 'sm')
 *   variant: 'default' | 'subtle' (default 'default')
 */
import { Bot } from 'lucide-react';

const SIZES = {
  xs: { box: 'px-1 py-0 text-[9px]', icon: 9 },
  sm: { box: 'px-1.5 py-0.5 text-[10px]', icon: 10 },
  md: { box: 'px-2 py-0.5 text-xs', icon: 12 },
};

export const AIBadge = ({ size = 'sm', variant = 'default', className = '' }) => {
  const s = SIZES[size] || SIZES.sm;
  const base =
    variant === 'subtle'
      ? 'bg-[#9b59b6]/10 text-[#9b59b6] border-[#9b59b6]/30'
      : 'bg-[#9b59b6] text-white border-[#9b59b6]';
  return (
    <span
      className={`inline-flex items-center gap-1 font-mono uppercase tracking-wider border rounded ${s.box} ${base} ${className}`}
      data-testid="ai-badge"
      title="AI-generated content"
    >
      <Bot size={s.icon} />
      AI
    </span>
  );
};

export default AIBadge;
